module.exports = __webpack_public_path__ + "img/logokindernino-blanco.c846f598.png";